import * as Yup from 'yup'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useCallback } from 'react'
import { useSnackbar } from 'notistack'
import { useNavigate, useParams } from 'react-router-dom'
import { Form, FormikProvider, useFormik } from 'formik'
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js'
import Page from 'src/components/Page.js'
import {KeyboardBackspaceOutlined} from '@material-ui/icons'
// material
import { LoadingButton } from '@material-ui/lab'
import { Autocomplete, Checkbox } from '@material-ui/core'
import {
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Switch,
  TextField,
  Typography,
  FormHelperText,
  Container,
  FormControlLabel,
} from '@material-ui/core'
import { Block } from 'src/pages/components-overview/Block.js'
// utils
// import { fData } from '../../../utils/formatNumber';
// routes
import { PATH_DASHBOARD } from 'src/routes/paths.js'
import { Link as RouterLink } from 'react-router-dom'
//
import Label from 'src/components/Label.js'
import axios from 'axios'
import { COMPANY_NAME, REST_API_END_POINT } from 'src/constants/Defaultvalues'

// ----------------------------------------------------------------------

// UserRoleEdit.propTypes = {
//   isEdit: PropTypes.bool,
//   currentUser: PropTypes.object
// };

export default function UserRoleViewData({viewId}) {
  const navigate = useNavigate()
  const user = JSON.parse(localStorage.getItem('user'))
  const userId = user.user_id
  const isClient = user.isClient
  const userType =isClient ? 3 : user.user_type
  let userRoleId = viewId
  const { enqueueSnackbar } = useSnackbar()
  const [permissionState, setPermissionState] = useState([])
  const [editUserData, setEditUserData] = useState([])
  const [checkedCheckboxIds, setCheckedCheckboxIds] = useState([])
  const [previousPermissions,setPreviousPermissions] = useState([]);
  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
  })

  const handleback = () => {
    window.history.back()
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: editUserData.name ? editUserData.name : '',
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        console.log('values.name', values.name)
        console.log('checkedCheckboxIds---', checkedCheckboxIds)
        if(checkedCheckboxIds.length>0){
          const permission = checkedCheckboxIds.join(',');
          const response = await axios.post(`${REST_API_END_POINT}settings/edit-user-role`, 
          {name:values.name,userId:userId,userRoleId:userRoleId,permissions:permission});
          if(response.data.status === 1){
            enqueueSnackbar(response.data.message, { variant: 'success' })
            resetForm()
            navigate(PATH_DASHBOARD.adminAccount.userRole, { state: { data: userRoleId } })
          }
          else if(response.data.status === 0){
            enqueueSnackbar(response.data.message, { variant: 'error' })
          }
          else {
            enqueueSnackbar("Server Error", { variant: 'error' })
          }
        }
        else{
          enqueueSnackbar("Please select atleast 1 user permission", { variant: 'error' })
        }
      } catch (error) {
        console.error("edit user role error : ",error)
        setSubmitting(false)
        setErrors(error)
      }
    },
  })

  const {errors,values,touched,handleSubmit,isSubmitting,setFieldValue,getFieldProps,} = formik

  const fetchData = async () => {
    try {
      axios.post(`${REST_API_END_POINT}settings/get-all-settings`, {userId,userType,})
        .then((response) => {
          const data=response.data.results;
          setPreviousPermissions(data.permissions)
        })
        .catch((error) => {console.error('userrole fetchData Error:', error)})
    } catch (error) {
      console.error('userrole fetchData Error:', error);
    }
  }

  const fetchEditData = async () => {
    try {
      axios.post(`${REST_API_END_POINT}settings/get-user-role`, { userRoleId })
        .then((response) => {setEditUserData(response.data.result)
          const editUserPermissions = response.data.result.user_permissions;
          const dataArray = editUserPermissions.split(',').map(Number);
         setCheckedCheckboxIds(dataArray)
        })
        .catch((error) => {
          console.error('userrole fetchEditData Error:', error)
        })
    } catch (error) {
      console.error('userrole fetchEditData Error:', error)
    }
  }

  useEffect(() => {
    fetchData()
    fetchEditData()
  }, [])

useEffect(()=>{
  const updatedPermissions = { ...previousPermissions };
  for (const moduleName in updatedPermissions ) {
    if (updatedPermissions .hasOwnProperty(moduleName)) {
      const modulePermissions = updatedPermissions [moduleName];
      for (const permission of modulePermissions) {
        permission.checked = checkedCheckboxIds.includes(permission.id);
      }
    }
  }
  setPermissionState(updatedPermissions );
},[previousPermissions,checkedCheckboxIds])

  return (
    <Page title={`User Role View | ${COMPANY_NAME}`}>
      <Container>
        {/* <HeaderBreadcrumbs heading="User Role View" /> */}
            <Grid container spacing={3}>
              <Grid item xs={12} md={10}>
                <Stack spacing={3}>
                  <Stack
                    justifyContent="space-between"
                    direction={{ xs: 'column', sm: 'column' }}
                  >
                    <Stack
                      direction={{ xs: 'column', sm: 'row' }}
                      spacing={{ xs: 3, sm: 2 }}
                      sx={{ mb: 4 }}
                    >
                      <TextField
                        fullWidth
                        label="Name"
                        type="text"
                        sx={{cursor:'auto'}}
                        InputProps={{ readOnly:true }}
                        {...getFieldProps('name')}
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                      />
                    </Stack>
                    {permissionState &&
                        Object.entries(permissionState).map(([moduleName, moduleData], index) => {
                            const checkedModuleData = moduleData.filter((item) => item.checked);
                            if (checkedModuleData.length === 0) return null; // Skip if no checked items
                            return (
                            <Stack key={index} spacing={{ xs: 2, sm: 1 }}>
                                <Stack>
                                <Typography variant="subtitle1">{moduleName === 'Request' ? 'Sales Order': moduleName === 'Jobs'? "Production": moduleName === "Receive Inventory" ? "Purchase Order":moduleName}</Typography>
                                {checkedModuleData.map((item, optionIndex) => (
                                    <FormControlLabel
                                    key={optionIndex}
                                    sx={{ marginLeft: '40px', cursor: 'auto' }}
                                    // label={item.name}
                                    label={item.name
                                      .replace(/request/gi, 'Sales Order')
                                      .replace(/Design Order Jobs?/gi, 'Design Jobs')
                                    }
                                    control={<Checkbox checked readOnly />}
                                    />
                                ))}
                                </Stack>
                            </Stack>
                            );
                        })}

                    {/* {permissionState &&
                      Object.entries(permissionState).map(
                        ([moduleName, moduleData], index) => {
                          const allChecked = moduleData.every((item) => item.checked)
                          const someChecked = moduleData.some((item) => item.checked)
                          return (
                            <Stack key={index} spacing={{ xs: 2, sm: 1 }}>
                              <Stack>
                                <FormControlLabel
                                  label={moduleName}
                                  sx={{cursor:'auto'}}
                                  control={
                                    <Checkbox
                                      checked={allChecked}
                                      indeterminate={someChecked && !allChecked}
                                      InputProps={{ readOnly:true }}
                                      sx={{cursor:'auto'}}
                                    //   onChange={() => {
                                    //     const updatedState = {
                                    //       ...permissionState,
                                    //       [moduleName]: permissionState[
                                    //         moduleName
                                    //       ].map((item) => ({
                                    //         ...item,
                                    //         checked: !allChecked,
                                    //       })),
                                    //     }
                                    //     setPermissionState(updatedState)

                                    //     const updatedIds = Object.entries(
                                    //       updatedState,
                                    //     ).flatMap(([module, items]) =>
                                    //       items
                                    //         .filter((item) => item.checked)
                                    //         .map((item) => item.id),
                                    //     )
                                    //     setCheckedCheckboxIds(updatedIds)
                                    //   }}
                                    />
                                  }
                                />
                                {moduleData.map((item, optionIndex) => (
                                <FormControlLabel
                                    key={optionIndex}
                                    sx={{ marginLeft: '40px',cursor:'auto' }}
                                    label={item.name}
                                    control={
                                      <Checkbox
                                      checked={item.checked || false}
                                      InputProps={{ readOnly:true }}
                                      sx={{cursor:'auto'}}
                                        // onChange={() => {
                                        //   const updatedState = {
                                        //     ...permissionState,
                                        //     [moduleName]: permissionState[
                                        //       moduleName
                                        //     ].map((currentItem, j) => {
                                        //       if (j === optionIndex) {
                                        //         return {
                                        //           ...currentItem,
                                        //           checked: !currentItem.checked,
                                        //         }
                                        //       }
                                        //       return currentItem
                                        //     }),
                                        //   }
                                        //   setPermissionState(updatedState)

                                        //   const updatedIds = Object.entries(
                                        //     updatedState,
                                        //   ).flatMap(([module, items]) =>
                                        //     items
                                        //       .filter((item) => item.checked)
                                        //       .map((item) => item.id),
                                        //   )
                                        //   setCheckedCheckboxIds(updatedIds)
                                        // }}
                                      />
                                    }
                                  />
                                )
                                )}
                              </Stack>
                            </Stack>
                          )
                        },
                      )} */}
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
      </Container>
    </Page>
  )
}
